module.exports = __webpack_public_path__ + "static/media/About_us.e34daadd.mp4";